<template>
  <v-card rounded>
    <v-card-title>
      <v-row no-gutters>
        <div>Xóa shipment</div>
        <v-spacer />
        <div class="">
          <v-btn
            :disabled="isLoading"
            text
            class="mr-2"
            @click="onCloseDialog"
            >Đóng</v-btn
          >
          <v-btn
            :disabled="isLoading"
            :loading="isLoading"
            color="error"
            @click="onDeleteOrderShipment"
            >Xóa</v-btn
          >
        </div>
      </v-row>
    </v-card-title>

    <v-card-text class="pb-6 pt-2">
      Bạn có chắc chắn muốn xóa shipment này không?
    </v-card-text>
  </v-card>
</template>

<script>
import PortPicker from '@/components/shared/local/vpl/PortPicker.vue';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import CustomerServicePicker from '@/components/shared/local/vpl/CustomerServicePicker.vue';

export default {
  components: { PortPicker, CustomerServicePicker },
  props: {
    item: {
      type: Object,
    },
  },
  data: () => ({
    isLoading: false,
  }),
  computed: {},
  async created() {},
  watch: {},
  methods: {
    ...mapActions('vpl/order', [
      'deleteOrderShipment',
      'fetchOrderShipmentList',
    ]),
    onCloseDialog() {
      this.$emit('close-dialog');
    },
    async onDeleteOrderShipment() {
      try {
        this.isLoading = true;
        await this.deleteOrderShipment({
          orderId: this.$route.params.id,
          id: this.item.id,
        });
        await this.fetchOrderShipmentList({ orderId: this.$route.params.id });
        this.$emit('close-dialog');
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style></style>
